import Mutations from '../../odata/mutations';

export default { ...new Mutations('brand'), ...new Mutations('brands') };
